import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the DprSectionsEventsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-dpr-sections-events',
  templateUrl: 'dpr-sections-events.html',
})
export class DprSectionsEventsPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {

  }

}



// WEBPACK FOOTER //
// ./src/pages/nav/nav-menus/nav-dpr-sections-submenu/dpr-sections-events/dpr-sections-events.ts